import { Grid, Paper } from "@mui/material";
import { action, API, controller } from "api";
import { Button, Input } from "controls";
import { Model, ToFormData, UseForm } from "hooks";
import { Form } from "layout";
import { useEffect, useState } from "react";

const AddEditType = ({ setShowForm, updData, setTypes, setAlert }) => {
  const { FollowUpTypeMdl } = Model();
  const [loading, setLoading] = useState(false);
  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInpChg,
    resetFormControls,
  } = UseForm(FollowUpTypeMdl);

  useEffect(() => {
    updData &&
      setValues((x) => ({
        ...x,
        ...updData,
        updDate: "",
        user: "",
        addDate: "",
      }));
    return () => {
      resetFormControls();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updData]);

  const validateForm = () => {
    let temp = {};
    temp.name = values.name !== "" ? "" : "Follow-Up type required";

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        if (res && (res.status === 201 || res.status === 200)) {
          if (setTypes && res.result.id) {
            updData
              ? setTypes((x) => [
                  ...x.map((j) => (j.id === res.result.id ? res.result : j)),
                ])
              : setTypes((x) => [res.result, ...x]);
          }
          setAlert({
            isOpen: true,
            type: "success",
            title: "Success",
            subTitle: res.msg,
          });
          setShowForm(false);
        } else if (res)
          setAlert({
            isOpen: true,
            type: "error",
            title: "Error",
            subTitle: res.msg,
          });
      };
      if (values.id === 0) {
        API(controller.FollowUpType + action.Post).post(
          ToFormData({ ...values, createDate: new Date().toISOString() }),
          onComplete
        );
      } else
        API(controller.FollowUpType + action.Put).put(
          ToFormData({ ...values, updateDate: new Date().toISOString() }),
          onComplete
        );
    }
  };

  const handleClose = () => {
    setShowForm(false);
  };

  return (
    <>
      <Form onSubmit={handleSubmit} noValidate>
        <Paper className="p-[10px]">
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              className="text-center p-[20px] mb-[10px] !pt-[30px] w-full"
            >
              <span className="font-medium text-[22px] uppercase text-gray-500">
                {updData ? "Update" : "Add"} Follow Type
              </span>
              <div className="relative flex justify-center mt-[5px]">
                <div className="border-bottom w-[60px]" />
              </div>
            </Grid>

            <Grid item xs={12}>
              <Input
                label="Name"
                name="name"
                value={values.name}
                error={errors.name}
                required={true}
                onChange={handleInpChg}
                size="large"
              />
            </Grid>
            <Grid item xs={12}></Grid>
            <Grid item xs={12} md={6}>
              <Button
                variant="text"
                size="large"
                onClick={handleClose}
                fullWidth
              >
                Cancel
              </Button>
            </Grid>
            <Grid item xs={12} md={6}>
              <Button loading={loading} size="large" type="submit" fullWidth>
                Submit
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Form>
    </>
  );
};

export default AddEditType;
